import styled from 'styled-components';

import { textSize, brand, ink, surface, tones } from '../../../../styles/brand';
export const StepFormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const FieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
`;

export const FieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.85)};
  color: ${tones.gray.text};
  display: block;
`;

export const ErrorText = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.78)};
  color: ${tones.red.text};
`;

export const PlainInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  height: 3.05rem;
  border: 0.5px solid
    ${props => (props.$hasError ? tones.red.border : surface.line)};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${ink};
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: ${brand.orange};
  }

  &::placeholder {
    color: #aaa;
  }

  &:disabled {
    background: #7b7a7a;
    color: ${ink};
    cursor: not-allowed;
  }
`;

export const TwoColumnRow = styled.div`
  display: flex;
  gap: 1rem;

  > * {
    flex: 1;
    min-width: 0;
  }
`;

export const WhenGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const WhenInputsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  input {
    flex: 1;
    min-width: 0;
  }
`;

export const WhenSeparator = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(1)};
  color: ${tones.gray.text};
  flex-shrink: 0;
`;

/* ── Modalidades ── */

export const CheckboxGroup = styled.div`
  display: flex;
  gap: 0.7rem;
  flex-wrap: wrap;
`;

export const CheckboxItemWrapper = styled.div<{
  $checked: boolean;
  $expanded?: boolean;
}>`
  display: flex;
  flex-direction: ${props => (props.$expanded ? 'column' : 'row')};
  align-items: ${props => (props.$expanded ? 'stretch' : 'center')};
  gap: 0.5rem;
  border: 1.5px solid ${props => (props.$checked ? brand.green : surface.line)};
  border-radius: 0.5rem;
  padding: ${props =>
    props.$expanded ? '0.75rem 0.85rem' : '0.45rem 0.85rem'};
  cursor: ${props => (props.$expanded ? 'default' : 'pointer')};
  user-select: none;
  transition: border-color 0.15s;
  ${props => props.$expanded && 'width: 100%;'}
`;

export const CheckboxItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

export const ModalitySettingsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-top: 0.6rem;
  border-top: 1px solid #f0f0f0;
`;

export const ModalitySettingItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const CheckboxBox = styled.div<{ $checked: boolean }>`
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 0.22rem;
  border: 2px solid ${props => (props.$checked ? brand.green : '#ccc')};
  background: ${props => (props.$checked ? brand.green : '#fff')};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: ${textSize(0.7)};
  transition:
    background 0.15s,
    border-color 0.15s;
`;

export const CheckboxItemLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.9)};
  color: ${ink};
`;

/* ── Categorias ── */

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
`;

export const CategorySelect = styled.select`
  height: 2.6rem;
  border: 1px solid ${surface.line};
  border-radius: 0.56rem;
  padding: 0 0.8rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.88)};
  color: ${tones.gray.text};
  background: #fff;
  outline: none;
  cursor: pointer;
  min-width: 9rem;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1.5px solid ${brand.green};
  border-radius: 0.4rem;
  padding: 0.35rem 0.65rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: ${textSize(0.82)};
  color: ${ink};
`;

export const TagRemove = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${tones.red.text};
  font-size: ${textSize(1)};
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
`;

/* ── Form buttons ── */

export const FormButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.8rem;
  padding-top: 1.2rem;
  border-top: 1px solid #f0f0f0;

  .secondary-button,
  .primary-button {
    height: 2.8rem;
    border-radius: 0.55rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: ${textSize(0.9)};
    padding: 0 1.6rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .secondary-button {
    border: 1px solid ${surface.line};

    &:hover {
      border: 1px solid ${brand.green};
      svg {
        transition: transform 0.3s;
        stroke: ${brand.green};
      }
    }
  }
`;

export const CancelButton = styled.button`
  height: 2.8rem;
  padding: 0 1.4rem;
  border: 1.5px solid ${surface.line};
  border-radius: 0.55rem;
  background: #fff;
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.9)};
  color: ${tones.gray.text};
  cursor: pointer;
  transition: border-color 0.2s;

  &:hover {
    border-color: #aaa;
  }
`;

export const SaveButton = styled.button`
  height: 2.8rem;
  padding: 0 1.6rem;
  border: none;
  border-radius: 0.55rem;
  background: ${brand.orange};
  font-family: 'RedHatDisplay-Bold';
  font-size: ${textSize(0.9)};
  color: #fff;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #e68900;
  }
`;
